import React from 'react';
import { DialogTitle, DialogContent, RadioGroup, FormControlLabel, Radio, Typography } from '@mui/material';
import { SimpleModal } from 'components/Modal';
import { StyledButton } from 'components/Buttons/DefaultButton/DefaultButton.styles';
import { ModalButtonContainer } from '../FeedbackPage.styles';

interface PositiveFeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
  hygienistFirstName: string;
  selectedFeedback: string;
  onFeedbackChange: (feedback: string) => void;
  onSubmit: (feedback: string) => void;
}

const PositiveFeedbackModal: React.FC<PositiveFeedbackModalProps> = ({
  isOpen,
  onClose,
  hygienistFirstName,
  selectedFeedback,
  onFeedbackChange,
  onSubmit
}) => {
  const feedbackOptions = [
    `"Thanks so much, ${hygienistFirstName}!"`,
    `"Great job, ${hygienistFirstName}!"`,
    `"Really appreciate it, ${hygienistFirstName}!"`,
    `"You were great, ${hygienistFirstName}!"`,
    "not"
  ];

  const handleSubmit = () => {
    onSubmit(selectedFeedback);
    onClose();
  };

  return (
    <SimpleModal isOpen={isOpen} onClose={onClose}>
      <DialogTitle sx={{ textAlign: 'center' }}>We're so glad!</DialogTitle>
      <DialogContent>
        <Typography align="left" gutterBottom>
          Spread the love and send {hygienistFirstName} a note of appreciation:
        </Typography>
        <RadioGroup
          value={selectedFeedback}
          onChange={(e) => onFeedbackChange(e.target.value)}
        >
          {feedbackOptions.map((option) => (
            <FormControlLabel
              key={option}
              value={option}
              control={<Radio />}
              label={option === "not" ? "Don't send a note" : option}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <ModalButtonContainer>
        <StyledButton
          variant="contained"
          onClick={handleSubmit}
        >
          Submit
        </StyledButton>
        <StyledButton
          variant="outlined"
          onClick={onClose}
        >
          Go Back
        </StyledButton>
      </ModalButtonContainer>
    </SimpleModal>
  );
};

export default PositiveFeedbackModal;
